import React, { useEffect } from 'react'
import ScreenSpinner from 'components/share/ScreenSpinner'
import { useLiveReportAuth } from '../hooks'

const PreflightLoginCheck = ({ children }: { children: React.ReactElement }) => {
  const {
    login: { status },
    handleLogin,
    notifySessionInvalid,
    isValidSession
  } = useLiveReportAuth()

  // Call the login API for both protected and unprotected reports; the live report service will manage authentication.
  useEffect(() => {
    if (isValidSession !== true) {
      handleLogin({ email: '', reportKey: '' })
    }
  }, [isValidSession, handleLogin])

  useEffect(() => {
    if (status === 'failed') {
      notifySessionInvalid()
    }
  }, [status, notifySessionInvalid])

  if (status === 'idle' || status === 'loading') {
    return <ScreenSpinner />
  }

  if (status === 'failed') {
    return null
  }

  return children
}

export default PreflightLoginCheck
